/**
 * Insert link to the head of the document
 * @param {string} href - href of the link
 * @param {'stylesheet' | 'preload'} rel - rel of the link
 * @param {'script' | 'style'} as - as of the link
 */
export const insertLink = (params: {
    href: string;
    rel: 'stylesheet' | 'preload';
    as?: 'script' | 'style';
}) => {
    const link = document.createElement('link');
    link.rel = params.rel;
    link.href = params.href;
    if (params.as) link.as = params.as;
    link.crossOrigin = 'anonymous';

    document.head.appendChild(link);
};
